import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { authApi } from "@api";
import { enumExternalAuthType, enumExternalMethod, PATH_HOME } from "@configs";
import { ILineLogin } from "@interfaces";
import { selectMerchant, setExternalLogin } from "@redux";
import { formatMessage, useNotify } from "@utils";

export const PageLineLogin = () => {
    //page hook
    const dispatch = useDispatch();
    const history = useHistory();
    const { error, success } = useNotify();
    const { t } = useTranslation();

    const merchant = useSelector(selectMerchant);
    const signUpMethod = merchant?.signUpSettings?.signUpMethod;
    let getParams = new URLSearchParams(window.location.search);
    let queryParams: {
        code: string;
        state: string;
    } = {
        code: getParams.get("code") || "",
        state: getParams.get("state") || "",
    };
    // //page variable
    // const queryParams = queryString.parse(window.location.search.substring(1));

    // const remember = window.sessionStorage.getItem("remember");
    // const { _id } = useSelector(selectMerchant);
    // const configClient = useSelector(selectConfigClient);
    let check = false;

    const isTechDomain = () => {
        const currentURL = window.location.href;
        return currentURL.includes(".app");
    };

    useEffect(() => {
        console.log("handleLogin in /line-login");
        history.replace(PATH_HOME);
        // handleLogin();

        // console.log("testparams", getParams);
        // if (queryParams.code) {
        //     // const lineState = JSON.parse(queryParams?.state as string) as ILineState;
        //     if (
        //         check
        //         // lineState.type === enumExternalAuthType.LINK_LINE
        //     ) {
        //         const lineLoginApi = LineApi(LINE_AUTH_URL);
        //         (async () => {
        //             const lineAccessToken = await lineLoginApi.login(queryParams.code as string);
        //             if (lineAccessToken.data) {
        //                 const lineLoginData: ILineLogin = {
        //                     token: lineAccessToken.data.access_token,
        //                     refreshToken: lineAccessToken.data.refresh_token,
        //                     tokenId: lineAccessToken.data.id_token,
        //                 };

        //                 try {
        //                     await authApi.updateLine(lineLoginData);
        //                     success(t("message.update_link_line_success"));
        //                 } catch (err: any) {
        //                     if (err.response) {
        //                         error(formatMessage(err.response));
        //                     } else {
        //                         error(t("message.try_again_text"));
        //                     }
        //                 } finally {
        //                     console.log("why user setting ?");
        //                     // history.push(PATH_USER_SETTING);
        //                 }
        //             } else {
        //                 error(t("message.try_again_text"));
        //             }
        //         })();
        //         //
        //         return;
        //     } else if (queryParams.state) {
        //         dispatch(
        //             setExternalLogin({
        //                 type:
        //                     signUpMethod === enumExternalMethod.LINE
        //                         ? enumExternalMethod.LINE
        //                         : enumExternalMethod.LINEOA_TEL,
        //                 isSignUp: false,
        //                 line: {
        //                     code: queryParams.code.toString(),
        //                     state: queryParams.state.toString(),
        //                 },
        //             })
        //         );
        //         console.log("line login home");
        //         history.push(PATH_HOME);
        //     } else {
        //         // dispatch(logout());
        //     }
        // }
    }, []);

    const handleLogin = async () => {
        await null;
        console.log("handleLogin in /line-login");
        // alert("handleLogin in /line-login");
        let getAccToken: any = "";
        let getTokenId: any = "";
        // console.log('profile', profile);
        // console.log('token', getAccToken);
        // console.log('id', getTokenId);

        if (queryParams.code) {
            console.log("handleLogin if");
            // const lineState = JSON.parse(queryParams?.state as string) as ILineState;
            if (
                check
                // lineState.type === enumExternalAuthType.LINK_LINE
            ) {
                (async () => {
                    const lineLoginData: ILineLogin = {
                        token: getAccToken || "",
                        refreshToken: "",
                        tokenId: getTokenId || "",
                    };
                    try {
                        await authApi.updateLine(lineLoginData);
                        success(t("message.update_link_line_success"));
                    } catch (err: any) {
                        if (err.response) {
                            error(formatMessage(err.response));
                        } else {
                            error(t("message.try_again_text"));
                        }
                    } finally {
                        console.log("why user setting ?");
                        // history.push(PATH_USER_SETTING);
                    }
                })();
                //
                return;
            } else if (queryParams.state) {
                dispatch(
                    setExternalLogin({
                        type:
                            signUpMethod === enumExternalMethod.LINE
                                ? enumExternalMethod.LINE
                                : enumExternalMethod.LINEOA_TEL,
                        isSignUp: false,
                        line: {
                            code: queryParams.code.toString(),
                            state: enumExternalAuthType.LOGIN,
                        },
                    })
                );
                console.log("line login home");
                history.push(PATH_HOME);
            } else {
                // dispatch(logout());
                dispatch(
                    setExternalLogin({
                        type:
                            signUpMethod === enumExternalMethod.LINE
                                ? enumExternalMethod.LINE
                                : enumExternalMethod.LINEOA_TEL,
                        isSignUp: false,
                        line: {
                            code: "new line login",
                            state: enumExternalAuthType.LOGIN,
                        },
                    })
                );
                history.push(PATH_HOME);
            }
        } else {
            console.log("handleLogin else");
            dispatch(
                setExternalLogin({
                    type:
                        signUpMethod === enumExternalMethod.LINE
                            ? enumExternalMethod.LINE
                            : enumExternalMethod.LINEOA_TEL,
                    isSignUp: false,
                    line: {
                        code: "new line login",
                        state: enumExternalAuthType.LOGIN,
                    },
                })
            );
            history.push(PATH_HOME);
        }
    };

    return <></>;
};
